import { render } from "./FooterPage.vue?vue&type=template&id=7c8bbfb2&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=7c8bbfb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c8bbfb2"

export default script